/**
 * Claude Code CLI `--permission-mode` values (see Anthropic / Claude Code docs).
 * Stored on prompt queue payloads and session turns for Claude sessions only.
 */

export const CLAUDE_CODE_PERMISSION_MODES = [
  'default',
  'acceptEdits',
  'plan',
  'auto',
  'dontAsk',
  'bypassPermissions',
] as const;

export type ClaudeCodePermissionMode = (typeof CLAUDE_CODE_PERMISSION_MODES)[number];

const MODE_SET = new Set<string>(CLAUDE_CODE_PERMISSION_MODES);

/** User preference key (User DO / PATCH me/preferences). */
export const CLAUDE_CODE_LAST_PERMISSION_MODE_PREF_KEY = 'claudeCodeLastPermissionMode';

export function isClaudeCodePermissionMode(value: string): value is ClaudeCodePermissionMode {
  return MODE_SET.has(value);
}

/** Returns a valid mode, or `default` when missing or invalid. */
export function normalizeClaudeCodePermissionModeInput(raw: unknown): ClaudeCodePermissionMode {
  if (typeof raw !== 'string') return 'default';
  const t = raw.trim();
  return isClaudeCodePermissionMode(t) ? t : 'default';
}
